export type Faq = { question: string; answer: string[] };

export const faqs: Faq[] = [
  {
    question: "What exactly is ALOPECIA CLINICAL BLUEPRINT™?",
    answer: [
      "It’s a digital educational reference collection designed to help qualified professionals and eligible learners organize their study of hair loss assessment, trichoscopy, differential diagnosis, and clinical documentation.",
      "It includes six specialized volumes and five complementary bonuses.",
    ],
  },
  {
    question: "Can I really complete an alopecia assessment in 15 minutes?",
    answer: [
      "The 15-minute framework is a proposed workflow for organizing an initial review of available clinical information.",
      "It is not a guarantee that a full clinical assessment or diagnosis can be completed in 15 minutes.",
      "Actual time requirements depend on the patient, available information, clinical complexity, and necessary investigations.",
    ],
  },
  {
    question: "What are the five stages of the framework?",
    answer: [
      "Patient history review. Hair loss pattern assessment. Trichoscopy findings review. Differential diagnosis review. Documentation and next steps.",
    ],
  },
  {
    question: "Which alopecia conditions are covered?",
    answer: [
      "The collection includes educational references on twelve conditions: androgenetic alopecia, alopecia areata, telogen effluvium, anagen effluvium, traction alopecia, trichotillomania, lichen planopilaris, frontal fibrosing alopecia, central centrifugal cicatricial alopecia, discoid lupus erythematosus affecting the scalp, folliculitis decalvans, and dissecting cellulitis of the scalp.",
    ],
  },
  {
    question: "Who is this collection for?",
    answer: [
      "It’s intended for dermatologists, qualified trichology professionals, hair restoration physicians, dermatology residents, and eligible healthcare learners.",
      "Clinical application must remain within the user’s professional qualifications and scope of practice.",
    ],
  },
  {
    question: "Is this a physical product?",
    answer: ["No. ALOPECIA CLINICAL BLUEPRINT™ is a digital educational collection."],
  },
  {
    question: "How will I receive the materials?",
    answer: [
      "Access is delivered digitally after your purchase. Your checkout page will explain the applicable delivery and access instructions.",
    ],
  },
  {
    question: "Can I download the files?",
    answer: [
      "Download availability and access terms are shown with the product delivery information. Please review it before purchasing.",
    ],
  },
  {
    question: "Can I use the materials in any country?",
    answer: [
      "The collection may be useful for international educational study.",
      "However, clinical standards, diagnostic requirements, professional scopes, and regulations vary by location. Always follow applicable local requirements.",
    ],
  },
  {
    question: "Does the system replace clinical judgment?",
    answer: [
      "No. The collection supports educational review and professional reference organization.",
      "It does not replace clinical judgment, appropriate investigations, or individualized medical assessment.",
    ],
  },
  {
    question: "Is this a complete clinical training course?",
    answer: [
      "No. It is an educational reference collection and does not confer professional qualifications or authorization to perform clinical procedures.",
    ],
  },
  {
    question: "Is this a recurring subscription?",
    answer: ["No. The collection is offered for a one-time payment of $27 USD."],
  },
  {
    question: "What if the collection isn’t right for me?",
    answer: ["Review the applicable refund terms and request procedure displayed at checkout."],
  },
  {
    question: "Does this system guarantee better diagnostic outcomes?",
    answer: [
      "No. The system is designed to support structured learning and initial information review.",
      "It does not guarantee diagnostic accuracy, clinical performance, or patient outcomes.",
    ],
  },
];
